export enum TrackingEvents {
  PRODUCTS_SEARCHED = 'Products Searched',
  PRODUCTS_CLICKED = 'Product Clicked',
}
